import {
  AddProductsToPricelistModalTranslation,
  DeletePricelistTranslation,
  EditPricelistTranslation,
  ExportPricelistToExcelModalTranslation,
  ExportPricelistToPdfModalTranslation,
  IncludeNetPriceTranslation,
  ModuleTranslation,
  NetPriceTranslation,
  PricelistDetailsTranslation,
  PricelistFormTranslation,
  PricelistsTranslation,
  ProductAccessoriesTranslation,
  ProductDetailsTranslation,
  ProductImageTranslation,
  ProductPricelistTranslation,
} from './ModuleTranslation';

const pricelistForm: PricelistFormTranslation = {
      name: {
        label: 'Name',
        placeholder: 'Name eingeben',
        maxLengthError: 'Der Name darf nicht länger als {maxLength} Zeichen sein.',
        requiredError: 'Bitte geben Sie einen Namen ein.',
      },
      description: {
        label: 'Beschreibung',
        placeholder: 'Kurze Beschreibung eingeben',
        maxLengthError: 'Die Beschreibung darf nicht länger als {maxLength} Zeichen sein.',
      },
  errors: {
    createFailed: 'Die Preisliste konnte nicht erstellt werden. Bitte versuchen Sie es erneut.',
    updateFailed: 'Die Preisliste konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.',
    nameAlreadyExists: 'Eine Preisliste mit diesem Namen existiert bereits. Bitte verwenden Sie einen anderen Namen.',
  },
};

const addToPricelistModal: AddProductsToPricelistModalTranslation = {
  triggerLabel: 'Zu meinen Preislisten',
  closeLabel: 'Schließen',
  heading: 'Zu meinen Preislisten hinzufügen',
  itemsToAddFormat: '{count} Artikel werden hinzugefügt',
  addedToPricelistFormat: '{count} Artikel zu "{name}" hinzugefügt',
  loadingLabel: 'Preislisten werden geladen',
  modeLabel: 'Die ausgewählten Produkte einer bestehenden oder einer neuen Preisliste hinzufügen',
  modes: {
    existing: 'Zu bestehender hinzufügen',
    new: 'Neue erstellen',
  },
  cancelLabel: 'Abbrechen',
  addLabel: 'Hinzufügen',
  addPendingLabel: 'Wird hinzugefügt…',
  createLabel: 'Erstellen',
  createPendingLabel: 'Wird erstellt…',
  selectForm: {
    label: 'Preisliste auswählen',
    addFailedError: 'Die Produkte konnten nicht zur Preisliste hinzugefügt werden. Bitte versuchen Sie es erneut.',
  },
  createForm: pricelistForm,
};

const netPrice: NetPriceTranslation = {
  label: 'Nettopreis',
  notAvailable: 'k. A.',
};

const productAccessories: ProductAccessoriesTranslation = {
  basePrice: 'Grundpreis',
  itemNo: 'Art.-Nr.',
  name: 'Beschreibung',
  price: 'Preis',
  priceOnDemand: 'auf Anfrage',
  netPrice,
};

const productPricelist: ProductPricelistTranslation = {
  basePrice: 'Grundpreis',
  heading: 'Preisliste',
  price: 'Preis',
  priceGroup: 'Preisgruppe',
  priceOnDemand: 'auf Anfrage',
  netPrice,
};

const productImage: ProductImageTranslation = {
  enlargeImageFormat: 'Bild von {name} vergrößern',
};

const includeNetPrice: IncludeNetPriceTranslation = {
  label: 'Nettopreise einbeziehen',
  noAgreementsReason: 'Es sind keine Händlervereinbarungen verfügbar.',
};

const exportToExcelModal: ExportPricelistToExcelModalTranslation = {
  closeLabel: 'Schließen',
  heading: 'Excel-Export',
  generatingLabel: 'Bitte warten Sie, bis die Datei erstellt wurde.',
  readyLabel: 'Ihre Datei ist bereit.',
  errorLabel: 'Die Datei konnte nicht erstellt werden. Bitte versuchen Sie es erneut.',
  exportLabel: 'Exportieren',
  downloadLabel: 'Herunterladen',
  includeNetPrice,
};

const exportToPdfModal: ExportPricelistToPdfModalTranslation = {
  closeLabel: 'Schließen',
  heading: 'PDF-Export',
  titleInputLabel: 'Titel',
  titleInputPlaceholder: 'Titel eingeben',
  titleSubmitLabel: 'Aktualisieren',
  loadingDataLabel: 'Bitte warten Sie, bis die Produkte geladen sind.',
  generatingLabel: 'Bitte warten Sie, bis die Datei erstellt wurde.',
  readyLabel: 'Ihre Datei ist bereit.',
  errorLabel: 'Die Datei konnte nicht erstellt werden. Bitte versuchen Sie es erneut.',
  downloadLabel: 'Herunterladen',
  includeNetPrice,
  document: {
    coverPage: {
      heading: 'Preisliste',
      createdAtLabel: 'Erstellt',
      itemsLabel: 'Artikel',
    },
    productSection: {
      itemNoLabel: 'Artikelnr.',
      detailsHeading: 'Produktdetails',
      pricelist: productPricelist,
      additionalInfoHeading: 'Zusätzliche Informationen',
      accessories: {
        heading: 'Zubehör',
        table: productAccessories,
      },
    },
  },
};

const editPricelist: EditPricelistTranslation = {
  label: 'Bearbeiten',
  modal: {
    closeLabel: 'Schließen',
    heading: 'Preisliste bearbeiten',
    cancelLabel: 'Abbrechen',
    submitLabel: 'Speichern',
    submitPendingLabel: 'Wird gespeichert…',
    form: pricelistForm,
  },
};

const deletePricelist: DeletePricelistTranslation = {
  label: 'Löschen',
  confirmationFormat: 'Möchten Sie "{name}" wirklich löschen? Dies kann nicht rückgängig gemacht werden.',
  successFormat: '"{name}" gelöscht',
  modal: {
    closeLabel: 'Schließen',
    heading: 'Preisliste löschen',
    cancelLabel: 'Abbrechen',
    confirmLabel: 'Löschen',
    confirmPendingLabel: 'Wird gelöscht…',
    error: 'Die Preisliste konnte nicht gelöscht werden. Bitte versuchen Sie es erneut.',
  },
};

const pricelists: PricelistsTranslation = {
  pageTitleFormat: 'Preislisten',
  pageDescriptionFormat: 'Durchsuchen Sie Ihre Preislisten',
  tabs: {
    products: 'Produkte',
    pricelists: 'Meine Preislisten',
  },
  pricelistListing: {
    searchPlaceholder: 'Suchen',
    listsFoundLabel: 'Gefundene Listen',
    loadingLabel: 'Preislisten werden geladen',
    loadingMoreLabel: 'Weitere Preislisten werden geladen',
    pricelistList: {
      pricelistListingEmpty: {
        message: 'Keine Preislisten gefunden',
        createLabel: 'Preisliste erstellen',
      },
      pricelistListingItem: {
        itemsLabel: 'Artikel:',
        createdAtLabel: 'Erstellt:',
        modifiedAtLabel: 'Zuletzt bearbeitet:',
        actionsLabelFormat: 'Aktionen für {name}',
      },
      itemActions: {
        edit: editPricelist,
        delete: deletePricelist,
      },
    },
    createPricelistModalTriggerLabel: 'Neue Preisliste',
    createPricelistModal: {
      closeLabel: 'Schließen',
      heading: 'Neue Preisliste erstellen',
      cancelLabel: 'Abbrechen',
      submitLabel: 'Erstellen',
      submitPendingLabel: 'Wird erstellt…',
      form: pricelistForm,
    },
  },
  productListing: {
    title: 'Preislisten',
    searchPlaceholder: 'Suchen',
    expansionToggle: {
      label: 'Alle Produktfamilien aus- oder einklappen',
      options: {
        collapseAll: 'Alle einklappen',
        expandAll: 'Alle ausklappen',
      },
    },
    productsFoundLabel: 'Gefundene Produkte',
    filters: {
      heading: 'Filter',
      brands: {
        label: 'Marke',
      },
      types: {
        label: 'Typ',
      },
      sectors: {
        label: 'Bereich',
      },
      priceRange: {
        label: 'Preis',
        range: {
          from: 'Von',
          to: 'Bis',
        },
      },
    },
    table: {
      title: 'Produkte',
      emptyText: 'Keine Produkte gefunden',
      loadingLabel: 'Produkte werden geladen',
      loadingMoreLabel: 'Weitere Produkte werden geladen',
      selectAll: 'Alle Produkte auswählen',
      selectProduct: 'Auswählen',
      expandFamily: 'Produkte anzeigen',
      collapseFamily: 'Produkte ausblenden',
      expandColumnLabel: 'Ausklappen',
      itemNo: 'Artikelnr.',
      image: 'Bild',
      productImage,
      brand: 'Marke',
      model: 'Modell',
      price: 'Preis',
      priceInfo: {
        label: 'Preisinformationen',
        content: 'Startpreise. Die Preise variieren je nach gewählten Stoffen und Optionen.',
      },
      fromLabel: 'ab',
      productsCountLabel: 'Produkte',
      newBadge: 'NEU',
      modelActionLabel: 'Preise',
      familyActionLabel: 'Info',
      actionLabel: 'Aktion',
    },
    selectionPanel: {
      selectedCountFormat: '{count} Artikel ausgewählt',
      export: 'Exportieren',
      clearSelection: 'Auswahl aufheben',
    },
    addToPricelistModal,
    exportToPdfModal,
    details: {
      closeLabel: 'Schließen',
      loadingLabel: 'Familiendetails werden geladen',
      specificationHeading: 'Spezifikation',
    },
    modelDetails: {
      closeLabel: 'Schließen',
      loadingLabel: 'Preise werden geladen',
      pricelist: {
        caption: 'Preisliste',
        productGroup: 'PG',
        basePrice: 'Grundpreis',
        price: 'Preis',
        priceOnDemand: 'auf Anfrage',
        agreementDiscount: 'Händlerrabatt laut Vereinbarung',
        netPrice,
      },
      detailsLinkLabel: 'Zur Produktseite für detaillierte Preise',
    },
  },
};

const productDetails: ProductDetailsTranslation = {
  pageTitleFormat: '',
  pageDescriptionFormat: 'Preise und Zubehör für {name}',
  backlinkLabel: 'Zurück',
  downloadLabel: 'Herunterladen',
  lastUpdatedLabel: 'Zuletzt aktualisiert:',
  itemNoLabel: 'Artikelnr.',
  addToPricelistModal,
  exportToPdfModal,
  familyDetails: {
    triggerLabel: 'Familiendetails',
    closeLabel: 'Schließen',
    descriptionHeading: 'Beschreibung',
    featuresHeading: 'Merkmale',
  },
  terms: {
    triggerLabel: 'AGB',
    closeLabel: 'Schließen',
    heading: 'Allgemeine Verkaufs- und Lieferbedingungen',
    introFormat: 'Dieses Dokument gilt für Vertragshändler von {brand}.',
    loadingLabel: 'AGB werden geladen',
  },
  closeLabel: 'Schließen',
  productDetailsHeading: 'Produktdetails',
  accessoriesHeading: 'Zubehör',
  additionalInfoHeading: 'Zusätzliche Informationen',
  pricelist: productPricelist,
  accessories: productAccessories,
};

const pricelistDetails: PricelistDetailsTranslation = {
  pageTitleFormat: '',
  pageDescriptionFormat: 'Preise für die Produkte in {name}',
  backlinkLabel: 'Zurück',
  exportLabel: 'Excel',
  downloadLabel: 'PDF/Drucken',
  settingsLabel: 'Einstellungen',
  itemsLabel: 'Artikel:',
  createdAtLabel: 'Erstellt:',
  modifiedAtLabel: 'Zuletzt bearbeitet:',
  regionLabel: 'Region',
  currencyLabel: 'Währung',
  pricesRefreshedAtLabel: 'Preise aktualisiert',
  currencyExcludingVatFormat: '{currency} (exkl. MwSt.)',
  searchPlaceholder: 'Suchen',
  productsLabel: 'Produkte in dieser Preisliste',
  itemsFoundLabel: 'Artikel',
  emptyText: 'Keine Artikel gefunden',
  loadingLabel: 'Artikel werden geladen',
  loadingMoreLabel: 'Weitere Artikel werden geladen',
  exportToExcelModal,
  exportToPdfModal,
  product: {
    actionsLabelFormat: 'Aktionen für {name}',
    pricelist: productPricelist,
    productImage,
    additionalInfoHeading: 'Zusätzliche Informationen',
    accessories: {
      heading: 'Zubehör',
      loadingLabel: 'Zubehör wird geladen',
      table: productAccessories,
    },
  },
  pricelistActions: {
    edit: editPricelist,
    delete: deletePricelist,
  },
  productActions: {
    remove: {
      label: 'Entfernen',
      confirmationFormat: 'Möchten Sie "{name}" wirklich aus dieser Preisliste entfernen?',
      successFormat: '"{name}" entfernt',
      modal: {
        closeLabel: 'Schließen',
        heading: 'Produkt entfernen',
        cancelLabel: 'Abbrechen',
        confirmLabel: 'Entfernen',
        confirmPendingLabel: 'Wird entfernt…',
        error: 'Das Produkt konnte nicht entfernt werden. Bitte versuchen Sie es erneut.',
      },
    },
  },
};

const translation: ModuleTranslation = {
  pricelistDetails,
  pricelists,
  productDetails,
};

export default translation;
